<template>
  <div class="slider-list-container">
    <h2 v-if="listTitle !== null" class="list-title my-4" v-text="listTitle" />
    <carousel
      v-bind="carouselSettings"
      :breakpoints="carouselBreakpoints"
      :mouse-drag="false"
      :touch-drag="isNavigationVisible"
    >
      <slide
        v-for="(item, index) in items"
        :key="index"
      >
        <slot class="card" name="card" :item="item" />
      </slide>
      <template #addons>
        <Navigation v-if="isNavigationVisible" />
      </template>
    </carousel>
  </div>
</template>

<script>
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Navigation } from 'vue3-carousel'
import { useMq } from 'vue3-mq'

export default {
  name: 'SliderList',
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  props: {
    listTitle: {
      type: String,
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const mq = useMq()

    return { mq }
  },
  data() {
    return {
      /**
       * default beállítása, hogy, hány kártya jelenleg meg az oldalon.
       * 0as szélességtől kezdve, utána a carouselBreakpoints alapján.
       */
      carouselSettings: {
        itemsToShow: 1,
        snapAlign: 'center',
      },
      /**
       * Oldal szélesség alapján meghatározza, hogy hány kártya látszódjon egyszerre.
       */
      carouselBreakpoints: {
        432: {
          itemsToShow: 2,
          snapAlign: 'start',
        },
        1025: {
          itemsToShow: 3,
          snapAlign: 'start',
        },
      },
    }
  },
  computed: {
    /**
     * Kijelző szélesség és megjelenítendő elemek alapján kiszámoljuk kell-e a navigáló nyilak megjelenítése.
     * @return {boolean}
     */
    isNavigationVisible() {
      if (this.mq.xs) {
        return true
      }
      if ((this.mq.md || this.mq.lg) && this.items.length <= 2) {
        return false
      }
      return !((this.mq.xxl || this.mq.xl) && this.items.length <= 3)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins/breakpoints';

.slider-list-container {
  max-width: 80rem;
}

.list-title {
 color: #101010;
 text-align: center;
 font-size: calc(1rem + 1.05vw);
 font-style: normal;
 font-weight: 700;
 line-height: normal;
 margin-bottom: 2.813rem;
}

.carousel {
  // a léptető nyilak pozicionálása miatt a kártya nem teljes szélességen van.
  width: 97%;
  margin: auto;
}

:deep(.carousel__track) {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

// slider belső classat írjuk felül ezért kell a :deep.
// szükséges a negativ érték használat, hogy ki tudjuk tolni a tartalomból.
:deep(.carousel__prev) {
  left: -2.188rem;
}

:deep(.carousel__next) {
  right: -2.188rem;
}

@include media-breakpoint-down(md) {
  // slider belső classat írjuk felül ezért kell a :deep.
  // szükséges a negativ érték használat, hogy ki tudjuk tolni a tartalomból.
  :deep(.carousel__prev) {
    left: -1.875rem;
  }

  :deep(.carousel__next) {
    right: -1.875rem;
  }
}

:deep(.carousel__next--disabled) {
  display: none;
}

:deep(.carousel__prev--disabled) {
  display: none;
}

// a slider elemből hogy ne lógjon ki a kártya igy a slothoz tartozó osztály módosítom.
:deep(.card-container) {
  margin: 0 5px;
}
</style>
